export const hasLegalStatus = patient => typeof patient.agencyLegalStatus === 'string'
  && Boolean(patient.agencyLegalStatus.trim());

// A missing legal status locks the patient down for everyone except case team members,
// overriding restricted/adopt permissions *and* hospital roles alike (per the "IDENTITY –
// Data Access Constraints" product bulletin) — so this check has to be usable independently
// of hasFullPatientIdentityAccess, which hospital users are otherwise allowed to bypass for
// restricted/adopt cases.
export const isBlockedByMissingLegalStatus = patient => !hasLegalStatus(patient)
  && !patient.isCaseTeamMember;

export const isRestrictedCase = patient => patient.restrictedFlag === '1';

export const isAdoptionCase = patient => patient.sourceCases
  && patient.sourceCases.some(sourceCase => sourceCase.caseCategory
    && sourceCase.caseCategory.toLowerCase() === 'adopt');

export const isRestrictedAdoptionCase = patient => isRestrictedCase(patient)
  && isAdoptionCase(patient);

export const hasFullPatientIdentityAccess = (patient, accessibleDivisions = []) => {
  if (!hasLegalStatus(patient)) {
    return patient.isCaseTeamMember;
  }

  if (!isRestrictedCase(patient) || patient.isCaseTeamMember) {
    return true;
  }

  const accessiblePatientDivision = accessibleDivisions.find(division => (
    division.divisionUid === patient.divisionUid
  ));
  const divisionPermissions = accessiblePatientDivision?.permissions || [];

  if (isAdoptionCase(patient)) {
    return divisionPermissions.some(permission => (
      permission.securityPermissionName === 'identityViewAdopt'
    ));
  }

  return divisionPermissions.some(permission => (
    permission.securityPermissionName === 'identityViewRestricted'
  ));
};
